// [GS] DELIVER ESTIMATE | PRODUCT PAGE | BY GS


(function () {
  'use strict';

  // Nomes dos dias da semana em português, na ordem que Date.getDay() retorna (0 = domingo)
  var WEEKDAYS_PT = ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'];

  // Nomes dos meses por extenso, na ordem que Date.getMonth() retorna (0 = janeiro)
  var MONTHS_PT = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];

  // Formata uma data como "quarta-feira, 22 de julho" a partir de um objeto Date
  function formatDate(d) {
    return WEEKDAYS_PT[d.getDay()] + ', ' + d.getDate() + ' de ' + MONTHS_PT[d.getMonth()];
  }

  // Soma "days" dias ÚTEIS a partir de uma data base, pulando sábado (6) e domingo (0)
  function addBusinessDays(base, days) {
    var d = new Date(base);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++; // só conta se for dia útil
    }
    return d;
  }

  // Função principal: lê os atributos data-* do HTML e escreve as datas calculadas na tela
  function init() {
    var el = document.getElementById('delivery-estimate');
    if (!el) return; // se o bloco não existir na página, não faz nada

    // Lê os dias mínimo/máximo definidos no Liquid (ou usa padrão se vier vazio/inválido)
    var minDays = parseInt(el.dataset.minDays, 10) || 2;
    var maxDays = parseInt(el.dataset.maxDays, 10) || 7;

    var today = new Date();

    // Calcula a data inicial e final da janela de entrega e escreve nos <strong>
    el.querySelector('.start-day').textContent = formatDate(addBusinessDays(today, minDays));
    el.querySelector('.end-day').textContent = formatDate(addBusinessDays(today, maxDays));
  }

  // Executa assim que o DOM estiver pronto (ou imediatamente, se já estiver pronto)
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();